/*
  Collection intro ("פתיח קטגוריה") – sections/collection-intro.liquid
  - Desktop arrows and fades on the subcategory row
  - Scrolls the row (never the page) so the active circle is in view
  - Re-checks the promo dates in the browser, because Shopify caches pages
*/
(() => {
  if (window.ciCollectionIntro) return;
  window.ciCollectionIntro = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cleanups = new WeakMap();

  function setupSubcats(nav) {
    const scroller = nav.querySelector('.ci-subcats__scroller');
    const tiles = nav.querySelectorAll('.ci-tile');
    const prev = nav.querySelector('.ci-subcats__arrow--prev');
    const next = nav.querySelector('.ci-subcats__arrow--next');
    if (!scroller || !tiles.length || !prev || !next) return null;

    const first = tiles[0];
    const last = tiles[tiles.length - 1];

    // Edges are tracked by what is visible, not by scrollLeft (negative and browser-specific in RTL).
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const fullyVisible = entry.intersectionRatio >= 0.99;
        if (entry.target === first) nav.toggleAttribute('data-at-start', fullyVisible);
        if (entry.target === last) nav.toggleAttribute('data-at-end', fullyVisible);
      });
      prev.hidden = nav.hasAttribute('data-at-start');
      next.hidden = nav.hasAttribute('data-at-end');
    }, { root: scroller, threshold: 0.99 });

    observer.observe(first);
    if (last !== first) observer.observe(last);

    // "Next" moves toward the inline end: left in RTL, right in LTR.
    const step = (direction) => {
      const rtl = getComputedStyle(scroller).direction === 'rtl';
      const sign = (direction === 'next') === rtl ? -1 : 1;
      scroller.scrollBy({
        left: sign * scroller.clientWidth * 0.8,
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    };
    const onPrev = () => step('prev');
    const onNext = () => step('next');
    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);

    // Relative maths, so it works in every browser in RTL. No scrollIntoView: it would scroll the page too.
    const active = nav.querySelector('.ci-tile__link[aria-current]');
    if (active) {
      const sc = scroller.getBoundingClientRect();
      const t = active.getBoundingClientRect();
      if (t.left < sc.left || t.right > sc.right) {
        scroller.scrollTo({
          left: scroller.scrollLeft + (t.left - sc.left) - (sc.width - t.width) / 2,
          behavior: 'auto',
        });
      }
    }

    return () => {
      observer.disconnect();
      prev.removeEventListener('click', onPrev);
      next.removeEventListener('click', onNext);
    };
  }

  // One expression, so an expired promo can never be shown again by the start-date check.
  function checkPromo(el) {
    const s = +el.dataset.start || 0;
    const e = +el.dataset.end || 0;
    const now = Date.now() / 1000;
    el.hidden = (s > 0 && now < s) || (e > 0 && now > e);
  }

  function init(root) {
    root.querySelectorAll('.ci-subcats').forEach((nav) => {
      if (cleanups.has(nav)) return;
      const cleanup = setupSubcats(nav);
      if (cleanup) cleanups.set(nav, cleanup);
    });
    root.querySelectorAll('[data-ci-promo]').forEach(checkPromo);
  }

  function destroy(root) {
    root.querySelectorAll('.ci-subcats').forEach((nav) => {
      const cleanup = cleanups.get(nav);
      if (cleanup) cleanup();
      cleanups.delete(nav);
    });
  }

  init(document);

  // Theme editor: re-run on the section that was re-rendered, disconnect the one that was removed.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
